// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tx-end[data-v-5384b785]{\n  text-align: end;\n}\n", ""]);
// Exports
module.exports = exports;
